<app-auth-layout [loading]="loading">
  <form (ngSubmit)="login()" class="flex flex-col h-full p-8 md:p-12">
    
    <h1
      class="font-bold py- text-center text-lg pb-4 uppercase md:text-xl md:pb-8 lg:text-2xl"
    >
      Log in
    </h1>

    <app-notification-alert [data]="notification"></app-notification-alert>

    <div class="py-4">
      <label
        class="font-bold text-grey-darker text-sm mb-2 block"
        htmlFor="email"
      >
        {{formLabels.userNameLabel}}
      </label>
      <input
        [(ngModel)]="payload.StudentNo"
        class="border rounded bg-gray-50 text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
        id="email"
        type="text"
        required
        placeholder="{{formLabels.userNameLabel}}"
      />
      <div *ngIf="errors.StudentNo" class="text-xs text-error-dark italic">
        Please enter your {{formLabels.userNameLabel}}
      </div>
    </div>

    <div class="pb-4">
      <label
        class="font-bold text-grey-darker text-sm mb-2 block"
        htmlFor="password"
      >
      {{formLabels.PasswordLabel}}
      </label>
      <div class="relative">
        <input
          [(ngModel)]="payload.Password"
          class="border rounded bg-gray-50 text-sm mb-3 w-full py-2 px-3 pr-10 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
          placeholder="******************"
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          required
        />
        <button type="button" (click)="showPassword = !showPassword"
          class="absolute right-3 top-4 text-gray-400 hover:text-gray-600 transition-colors">
          <svg *ngIf="!showPassword" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          <svg *ngIf="showPassword" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
          </svg>
        </button>
      </div>
      <div *ngIf="errors.Password" class="text-xs text-red-500 italic">
        Please enter a {{formLabels.PasswordLabel}}.
      </div>
    </div>

    <div 
     class="text-right">
      <a
        routerLink="{{formLabels.ForgotLink}}"
        class="font-bold text-sm text-primary inline-block align-baseline hover:text-primary-dark hover:underline"
      >
      {{formLabels.ForgotLabel}}
      </a>
    </div>

    <div class="py-4">
      <app-button-primary type="submit" [disabled]="loading" class="w-full">
        Sign In
      </app-button-primary>
    </div>

  </form>
  
  <!-- <div 
  class="text-right m-3">
   <a
     href="/{{formLabels.PortalLink}}/login"
     class="font-bold text-sm text-primary inline-block align-baseline hover:text-primary-dark hover:underline"
   >
   Login to {{formLabels.PortalLabel}} Portal
   </a>
 </div> -->
</app-auth-layout>
